import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import {
  CompletedCard,
  CompletedCardHeader,
  CompletedCardIcon,
  CompletedCardTitle,
  CompletedFieldGrid,
  CompletedField,
} from '../../../screens/CompletedQuotes/CompletedV2.styles';

function CompletedRiskQuoteScreenOfflineInfo({
  rc_quotation, risk,
}) {
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  return (
    <div className="col-12 col-md-6">
      <CompletedCard className="mb-3 polizze-emessa-status-step-three">
        <CompletedCardHeader>
          <CompletedCardIcon>
            <FontAwesomeIcon icon={faShieldAlt} />
          </CompletedCardIcon>
          <CompletedCardTitle>
            Dati
            {' '}
            {quoteTypes.find((t) => t.id === risk.quote_type).name}
          </CompletedCardTitle>
        </CompletedCardHeader>
        <CompletedFieldGrid>
          <CompletedField>
            <dt>Compagnia</dt>
            <dd>{rc_quotation?.company?.name}</dd>
          </CompletedField>

          <CompletedField>
            <dt>Stato</dt>
            <dd>
              {rc_quotation.status === 7 && 'Polizza Emmesa'}
            </dd>
          </CompletedField>

          <CompletedField>
            <dt>Data Decorrenza</dt>
            <dd>
              {moment(rc_quotation.insurance_request.policy_effective_date)
                .toDate()
                .toLocaleDateString('it-IT')}
            </dd>
          </CompletedField>

          <CompletedField>
            <dt>Frequenza Pagamento</dt>
            <dd>
              {rc_quotation.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}
            </dd>
          </CompletedField>

          <CompletedField>
            <dt>Pagato</dt>
            <dd>
              {risk.amount_paid === null
                ? '0'
                : risk.amount_paid.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              {' '}
              €
            </dd>
          </CompletedField>

          {/* Da Pagare (temporarily hidden)
          <CompletedField>
            <dt>Da Pagare</dt>
            <dd>
              {risk.amount_paid === risk.amount
                ? '0'
                : (
                  Math.ceil(risk.amount * 100) / 100
                  - risk.amount_paid
                ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              {' '}
              €
            </dd>
          </CompletedField>
          */}

          <CompletedField>
            <dt>Prossimo Pagamento</dt>
            <dd>
              {moment(rc_quotation.insurance_request.policy_effective_date)
                .add(Math.floor(365 / rc_quotation.payment_frequency), 'days')
                .toDate()
                .toLocaleDateString('it-IT')}
            </dd>
          </CompletedField>

          <CompletedField>
            <dt>Premio</dt>
            <dd>
              {risk.amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              {' '}
              €
            </dd>
          </CompletedField>

          {/* Totale (temporarily hidden)
<CompletedField className="full total">
            <dt>Totale</dt>
            <dd>
              {(
                rc_quotation.amount
                + rc_quotation.brokerage_amount
                + (rc_quotation.quotation_services.length > 0
                  ? rc_quotation.quotation_services[0].amount_gross
                  : 0)
              ).toFixed(2)}
              {' '}
              €
            </dd>
          </CompletedField>
*/}
        </CompletedFieldGrid>
      </CompletedCard>
    </div>
  );
}

export default CompletedRiskQuoteScreenOfflineInfo;
